import Text, {
  Paragraph, Caption, Label, Subtitle,
} from './Text';

export default Text;
export {
  Paragraph,
  Caption,
  Label,
  Subtitle,
};
